import { Component, Input, OnInit, ViewChild  } from '@angular/core';
import { MatTableDataSource, MatPaginator } from '@angular/material';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material';
import { Title } from '@angular/platform-browser';
import { PropertiesService } from 'src/app/_services/company/properties.service';
import { LoadingService } from 'src/app/_services/loading.service';
import { NotificationService } from 'src/app/_services/notification.service';
import { UsersService } from 'src/app/_services/users.service';

@Component({
  selector: 'app-app-users',
  templateUrl: './app-users.component.html',
  styleUrls: ['./app-users.component.css']
})
export class AppUsersComponent implements OnInit {

  @Input() public is_role: string = null;
  displayedColumns: string[] = ['CompanyId','Name', 'Email', 'Role', 'RegistrationDate', 'Status', 'Actions'];

  dataSource: MatTableDataSource<any>;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  searchKey: string;

  constructor(private titleService: Title,
    private dialog: MatDialog,
    public usersService: UsersService) { }

  ngOnInit() {
    this.titleService.setTitle('App Users');
    this.onLoadUsers();
  }

  onLoadUsers() {
    var result = this.usersService.get_users().subscribe(data=> {
      if(this.is_role){
        this.dataSource = new MatTableDataSource<any>(data['dataList'].filter(x=> x.role == this.is_role));
      }
      else{
        this.dataSource = new MatTableDataSource<any>(data['dataList']);
      }
      this.dataSource.paginator = this.paginator;
    });
  }

  applyFilter(){
    this.dataSource.filter = this.searchKey.trim().toLocaleLowerCase();
  }
  
  onSearchClear(){
    this.searchKey = "";
    this.applyFilter();
  }

  onCreate() {
    const matDialogConfig = new MatDialogConfig();
    matDialogConfig.disableClose = true;
    matDialogConfig.autoFocus = true;
    matDialogConfig.width = "40%";
    matDialogConfig.position = { top: '0px' }
    //this.dialog.open(CreateCompanyDialog, matDialogConfig);
    this.dialog.open(CreateAppUsersDialog, matDialogConfig).afterClosed().subscribe(res=>{
      this.onLoadUsers();
    });
  }

  onEdit(row) {
    this.usersService.populateForm(row);
    const matDialogConfig = new MatDialogConfig();
    matDialogConfig.disableClose = true;
    matDialogConfig.autoFocus = true;
    matDialogConfig.width = "40%";
    matDialogConfig.position = { top: '0px' }
    //this.dialog.open(CreateCompanyDialog, matDialogConfig);

    this.dialog.open(CreateAppUsersDialog, matDialogConfig).afterClosed().subscribe(res=>{
      this.onLoadUsers();
    });
  }

}


/* Create Users */

@Component({
  selector: 'create-app-users-dialog',
  templateUrl: 'create-app-users-dialog.html',
  })
  export class CreateAppUsersDialog {
  
  propertyList: any;
  pwdBoxHide = true;

  constructor(private dialogRef: MatDialogRef<AppUsersComponent>,
    private loading : LoadingService,
    private notificationService: NotificationService,
    public usersService: UsersService,
    public propertiesService: PropertiesService,) {
  }

  ngOnInit() {
    this.onBindDropdown();
  }
  
  onBindDropdown(){
    this.propertiesService.get_properties().subscribe(data=> {
      this.propertyList = data['dataList'];
    });      
  }
  
  
  
  onUsersAddedFormSubmit(formData: any)
  {
      if (this.usersService.users_added_form.valid)
      {
      this.loading.spin$.next(true);
      if(!this.usersService.users_added_form.controls['id'].value)
      {
        // Insert Data
        this.usersService.insert_users_details(formData).subscribe(data=>{
          //console.log(data);
          if (data['status']) 
          {
            this.notificationService.success(data['message']);  
            this.usersService.users_added_form.reset();
            this.onClose();
            this.loading.spin$.next(false);
          } 
          else 
          {
            this.notificationService.error(data['error_message']);
            this.loading.spin$.next(false);
          }
        });
      }
      else
      {
        // Update Data
        this.usersService.update_users_details(formData).subscribe(data=>{
          if (data['status']) 
          {
            this.notificationService.success(data['message']);  
            this.usersService.users_added_form.reset();
            this.onClose();
            this.loading.spin$.next(false);
          } 
          else 
          {
            this.notificationService.error(data['error_message']);
            this.loading.spin$.next(false);
          }
        });
      } 
    }
  }   
  
  onClose(){
      this.dialogRef.close();
      this.usersService.users_added_form.reset();
  }
  
  }
  
